import { useState } from "react";
import { IonContent, IonPage } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { closeOutline } from "ionicons/icons";
import { Grid, Typography } from "@material-ui/core";
import Header from "src/components/Header";
import ResumenCupos from "../components/ResumenCupos";
import ListaAsignaciones from "../components/ListaAsignaciones";
import AnalisisAsignados from "../components/AnalisisAsignados";

// Detalle de un punto de servicio: resumen de cupos + lista de asignaciones
// con su horario por dia y el formulario de agregar (estilo EMSYS).
const AsignacionesV2Detalle: React.FC = () => {
  const history = useHistory();
  const psId = sessionStorage.getItem("ps_id") || "";
  const psNombre = sessionStorage.getItem("ps_nombre") || "";
  const [refreshKey, setRefreshKey] = useState(0);

  const botonCerrar = {
    icono: closeOutline,
    action: () => history.goBack(),
  };

  return (
    <IonPage>
      <Header titulo="Detalle de Asignaciones" botonIzq={botonCerrar} />
      <IonContent id="asignaciones-v2-detalle">
        <div className="container">
          <div className="mt-3">
            <Typography
              variant="h6"
              style={{ textAlign: "center", background: "#910434", color: "white", padding: 6, marginBottom: 8 }}
            >
              {psNombre}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <ResumenCupos psId={psId} refreshKey={refreshKey} />
              </Grid>
              <Grid item xs={12}>
                <ListaAsignaciones psId={psId} onChanged={() => setRefreshKey((k) => k + 1)} />
              </Grid>
              <Grid item xs={12}>
                <AnalisisAsignados psId={psId} />
              </Grid>
            </Grid>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default AsignacionesV2Detalle;
